export default "__VITE_ASSET__xkMZzylZ__"